import { initCloseQAAssistant } from './actions/closeQAAssistant';
import { LOGO_ID } from './constants';
import { handleMessageFromIframe } from './handleIframeMessage/handleIframeMessage';
import { pushTagData } from './tag/pushTagData';
import { serializeTagData } from './tag/serializeTagData';

export const onIframeLoaded = (appUrlSrc: string) => (iframe: HTMLIFrameElement) => {
  pushTag(iframe);

  document.getElementById(LOGO_ID)!.classList.remove('ab-assistant-not-loaded');

  const messageListenerCallback = handleMessageFromIframe(appUrlSrc);
  window.addEventListener('message', messageListenerCallback);
  initCloseQAAssistant(messageListenerCallback);
};

const pushTag = async (iframe: HTMLIFrameElement) => {
  if (iframe.contentWindow) {
    const tagData = await serializeTagData(() => pushTag(iframe));
    if (tagData) {
      pushTagData(tagData);
    }
  }
  setTimeout(() => pushTag(iframe), 1000);
};
